import React, { useEffect, useState } from 'react';
import { Tabs, Alert } from 'antd';
import { useTranslation } from "react-i18next";

import { repeatObjects, isGroupInput, groupSubsections, getLastRow, showHideInput } from './helper';

import Group from './components/group';
import Input from './components/input';
import RepeatableGroup from './components/repeatableGroup';
import RepeatableModals from './components/repeatableModals';
import { GetIcon } from 'datastake-daf/dist/components';
import { getInputLabel } from '../Edit/helper';
import ExtraLinkingData from './components/extraLinkingData';

const Content = ({
  style = {},
  form = {},
  data = {},
  groupConfig = {},
  linkingData = {},
  linkingForms = {},
  ajaxOptions = [],
  extraLinking = null,
}) => {
  const { i18n: { language } } = useTranslation();

  const groupSingle = (grps) => {
    const form = Object.keys(grps).reduce((f, gKey) => {
      if (
        grps[gKey].inputType !== 'modal' &&
        !isGroupInput(grps[gKey], false, data) &&
        !isGroupInput(grps[gKey], true, data) &&
        grps[gKey].display !== 'group' &&
        !grps[gKey].viewGroup &&
        !grps[gKey].component) {
        if (grps[gKey].group && !f[grps[gKey].group]) {
          f[grps[gKey].group] = {};
          Object.assign(f[grps[gKey].group], { [gKey]: grps[gKey] });
        } else if (grps[gKey].group && f[grps[gKey].group]) {
          Object.assign(f[grps[gKey].group], { [gKey]: grps[gKey] });
        }
      }
      return f;
    }, {});
    return form;
  }

  const getDisplayGroupConfig = (groups, key) => {
    return Object.keys(groups).reduce((items, gKey) => {
      if (groups[gKey].viewGroup === key) {
        const { viewGroup, ...gCfg } = groups[gKey];
        items[gKey] = gCfg;
      }
      return items;
    }, {});
  }

  const getComponent = (component, key, config) => {
    switch (component) {
      case 'repeatableModals':
        return <RepeatableModals
          key={key}
          name={key}
          data={data}
          config={config}
          linkingData={linkingData}
          linkingForms={linkingForms}
          ajaxOptions={ajaxOptions}
        />;
      default:
        return <p>Component</p>;
    }
  }

  const isDisplayGroup = (input) => input.display && input.display === 'group';
  const isSingleModal = (input) => input.inputType && input.inputType === 'modal';
  const hasComponent = (input) => input.component && typeof input.component === 'string';

  const typeRender = (groups, singleGroupsKeys, addedContent) => {
    const _length = Object.keys(groups || {}).length;
    const isEven = _length % 2 === 0;

    return repeatObjects(groups, (key, ind) => {
      // normal group
      return hasComponent(groups[key]) ? getComponent(groups[key].component, key, groups[key]) : isGroupInput(groups[key], false, data)
        ? (<Group
          key={key}
          name={key}
          linkingData={linkingData}
          config={groups[key]}
          data={data}
          allData={data}
          linkingForms={linkingForms}
          cols={2}
          ajaxOptions={ajaxOptions}>
        </Group>
        )
        // repeatable group
        : isGroupInput(groups[key], true, data)
          ? <RepeatableGroup
            key={key}
            name={key}
            config={groups[key]}
            data={data}
            allData={data}
            linkingData={linkingData}
            linkingForms={linkingForms}
            ajaxOptions={ajaxOptions}>
          </RepeatableGroup>
          // single inputs grouped
          : singleGroupsKeys.includes(key) ? (() => {
            if (!addedContent.includes(key)) {
              const currentGroup = Object.keys(groupSingle(groups))
                .find(k => Object.keys(groupSingle(groups)[k]).includes(key));
              addedContent.push(...Object.keys(groupSingle(groups)[currentGroup]));
              const config = groupSingle(groups)[currentGroup];
              if (groups[key].viewShowIf) {
                if (!showHideInput(groups[key], data)) {
                  return null;
                }
              }
              return <div className="group" key={`${currentGroup}-${Date.now()}`}>
                {groupConfig[currentGroup] ? <div className="title">
                  <h1>{groupConfig[currentGroup][language]}</h1>
                </div> : null}
                <Input
                  key={key}
                  name={config.dataId || key}
                  config={config}
                  data={data}
                  allData={data}
                  linkingData={linkingData}
                  className={
                    isEven ? (
                      (ind === _length - 1 || ind === _length - 2) ? 'last' : undefined
                    ) : ind === _length - 1 ? 'last' : undefined}
                  linkingForms={linkingForms}
                  ajaxOptions={ajaxOptions}
                  cols={2}>
                </Input>
              </div>
            }
          })()
            // display group
            : isDisplayGroup(groups[key])
              ? (
                <div className="group display" key={key}>
                  <div className="title">
                    <h1>{groups[key].label}</h1>
                  </div>
                  {typeRender(getDisplayGroupConfig(groups, key), singleGroupsKeys, addedContent)}
                </div>
              )
              // single modal
              : isSingleModal(groups[key])
                ? (
                  <div className="group" key={key}>
                    <div className="title">
                      <h1>{groups[key].outputLabel || getInputLabel(groups[key], data)}</h1>
                    </div>
                    <Input
                      key={key}
                      parent={key}
                      name={groups[key].dataId || key}
                      config={groups[key]}
                      className="last"
                      data={data}
                      allData={data}
                      linkingData={linkingData}
                      linkingForms={linkingForms}
                      ajaxOptions={ajaxOptions}
                      cols={2}>
                    </Input>
                  </div>
                )
                : null;
    });
  }

  useEffect(() => {
    setTimeout(() => {
      const groups = Array.from(document.getElementsByClassName('group'));
      const rows = Array.from(document.querySelectorAll('.repetable-row-extra'));
      rows.forEach(row => {
        const inputs = Array.from(row.querySelectorAll('.input'));
        const lasts = getLastRow(inputs.map((i, ind) => ind), 4);
        if (lasts) {
          lasts.forEach(index => inputs[index].classList.add('last'));
        }
      });
      groups.forEach(group => {
        // const isRepeatable = Array.from(group.classList).includes('repeatable');
        const inputs = Array.from(group.querySelectorAll('.input'));
        // if (inputs.length && !isRepeatable) {
        //   if (inputs.length % 2 === 0) {
        //     inputs[inputs.length - 1].classList.add('last');
        //     inputs[inputs.length - 2].classList.add('last');
        //   } else {
        //     inputs[inputs.length - 1].classList.add('last');
        //   }
        // }
        // remove groups without inputs
        if (!inputs.length) {
          group.remove();
        }
      });
    }, 200)
  }, [form, data])

  const [extraRequestSent, setExtraRequestSent] = useState({});
  const [extraRequestLoading, setExtraRequestLoading] = useState({});
  const [extraRequestData, setExtraRequestData] = useState({});
  const hasSubSections = false;

  const renderContent = (f, showTitle = true) => {
    if (f) {
      const alertType = ['error', 'warning', 'info', 'success'];
      if (f.alertConf && f.alertConf.type === 'warning') {
        return <Alert message={f.alertConf.text} type={f.alertConf.type} showIcon />
      }
      let { label, icon, position, ...groups } = f;
      groups = Object.keys(groups).reduce((items, key) => {
        if (!groups[key].excludeFromView) {
          items[key] = groups[key];
        }
        return items;
      }, {});
      const addedContent = [];
      const singleGroupsKeys = [].concat(...Object.keys(groupSingle(groups))
        .map(key => Object.keys(groupSingle(groups)[key])));
      return <>
        <div className="wrapper" key={Date.now()}>
          {showTitle ? <h1 className="title">{f ? getInputLabel(f, data) : ''}</h1> : null}
          {f.alertConf ? <Alert className="w-100" style={{ marginBottom: '20px' }} message={f.alertConf.text} type={
            alertType.includes(f.alertConf.type) ? f.alertConf.type : 'info'
          } showIcon /> : null}
          {typeRender(groups, singleGroupsKeys, addedContent)}
          {extraLinking ? (
            <ExtraLinkingData
              config={extraLinking}
              extraRequestSent={extraRequestSent}
              setExtraRequestSent={setExtraRequestSent}
              data={data}
              extraRequestLoading={extraRequestLoading}
              setExtraRequestLoading={setExtraRequestLoading}
              extraRequestData={extraRequestData}
              setExtraRequestData={setExtraRequestData}
            />
          ) : null}
        </div>
      </>
    }
  }

  let groupSections = [];
  if (hasSubSections) {
    groupSections = groupSubsections(form);
  }

  return (
    <div className="content" style={style}>
      {!hasSubSections ? renderContent(form) : (
        <React.Fragment>
          <h1 className="title">{form ? getInputLabel(form, data) : ''}</h1>
          <Tabs
            className="section-tabs"
            items={repeatObjects(groupSections, (key) => {
              const section = groupSections[key];

              return {
                style: { maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' },
                label: (
                  <span>
                    {section.icon ?
                      <GetIcon icon={section.icon} /> : null} {getInputLabel(section, data)}
                  </span>
                ),
                key: key,
                tabKey: key,
                children: renderContent(groupSections[key], false),
              };
            })}
          />
        </React.Fragment>
      )}
    </div>
  );
}

export default Content;
